export const toTitleCase = (string) => {
  //console.log(typeof string);
  if (typeof string !== "string") return string;

  string = string.toLowerCase();
  let firstChar = string.charAt(0).toUpperCase();
  string = string.substring(1);

  return firstChar + string;
};
